import styled from "styled-components";

export const Container = styled.div`
	grid-area: "MN";
	background: var(--dark-green);
	border-radius: 10px;

	overflow-y: hidden;

	display: flex;
	justify-content: flex-start;
	align-items: flex-start;

	height: calc(100vh - 20px);
	.menuOpen {
		z-index: 1000;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		height: calc(100vh - 20px);

		width: 250px;
		margin: 0 auto;

		padding: 12px;

		ul {
			display: flex;
			flex-direction: column;
			gap: 10px;

			.top {
				display: flex;
				justify-content: flex-start;

				button {
					color: white;
					svg {
						stroke-width: 1px;
						font-size: 25px;
					}
				}
			}
		}

		li {
			background-color: var(--very_light-green);
			border-radius: 10px;
			height: 35px;
			width: 228px;
			display: flex;
			align-items: center;
			justify-content: center;

			transition: 600ms ease-in-out;

			a {
				display: flex;
				gap: 10px;
				align-items: center;
				width: 100%;
				color: white;
				padding: 0 10px;

				svg {
					font-size: 20px;
				}
			}
		}
		li:hover {
			background-color: var(--main-green);
		}

		button {
			display: flex;
			gap: 15px;
			font-size: 20px;

			align-items: center;
			color: #f8a4a4;

			transition: 600ms ease-in-out;
			svg {
				font-size: 20px;
				stroke-width: 2px;
			}

			p {
				transition: ease;
			}
		}
		button:hover {
			color: #f85f5f;
		}
	}
`;
